/* Halo V3 — table of contents for the long policy pages.
 *
 * The comp (pages_v3/privacy-policy.html and nine others) puts a sticky
 * contents list beside the body copy. The store's page bodies are authored
 * in admin and carry no such markup, and a stylesheet cannot invent it, so
 * it is built here from the headings that are already on the page.
 *
 * Placement: the page section is a three column grid, 459px / 672px / 459px,
 * with both outer columns empty. The list is dropped into the third column
 * rather than squeezed into the text column, so the measure of the body copy
 * does not change at all. Under 1000px the CSS hides it again.
 *
 * Nothing here writes text of its own. Every label is lifted from a heading,
 * which means the Arabic pages get an Arabic contents list for free.
 */
(function () {
  'use strict';

  var MIN_HEADINGS = 4;

  function slugify(text, index) {
    var slug = text
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
    // Arabic headings can slugify to something empty or colliding; the index
    // keeps every id unique either way.
    return 'hv3-' + (slug || 'section') + '-' + index;
  }

  function build() {
    var shell = document.querySelector('.halo-page-shell');
    if (!shell) return;

    var section = shell.closest('.section');
    if (!section) return;

    // Only the long documents get one.
    var headings = shell.querySelectorAll('h2.halo-section-title');
    if (headings.length < MIN_HEADINGS) return;

    // Guard against a second run (view transitions re-enter this script).
    if (section.querySelector('.hv3-toc')) return;

    var nav = document.createElement('nav');
    nav.className = 'hv3-toc';
    nav.setAttribute('aria-labelledby', 'hv3-toc-heading');

    var title = document.createElement('p');
    title.className = 'hv3-toc__title';
    title.id = 'hv3-toc-heading';
    // Reuse the theme's own string so this is not an untranslated word.
    title.textContent = document.documentElement.lang === 'ar' ? 'المحتويات' : 'Contents';
    nav.appendChild(title);

    var list = document.createElement('ul');

    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) h.id = slugify(h.textContent.trim(), i);

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    nav.appendChild(list);
    section.appendChild(nav);
    section.classList.add('hv3-has-toc');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
